import React from 'react';
import CardLeft from './card-left';
import Card from '../card/components/card';
import { CardData } from '../card';
import { Service } from '../../../../../hoc/context/product/context-model';

const FtoCard: React.FC<{ service: Service; data: CardData; printMode?: boolean }> = ({
	service,
	data,
	printMode = false,
}) => {
    return (
		<Card data={data} printMode={printMode}>
			<CardLeft service={service} data={data} printMode={printMode} />
		</Card>
	);
}

export default FtoCard;